import client from './client';

export const getTimeSlots = async (params) => {
    return (await client('/apps/hb-cp/api/static/timeslots', {params})).time_slots;
}